module.exports = __webpack_public_path__ + "static/pic10-b97a7c34df53eb85a1d855360c1b52b2.jpg";